import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { ProviderStore } from "../../store/provider/provider.store";

export const providersByClinicResolver: ResolveFn<any> = async () => {
    const providerStore = inject(ProviderStore)
    try {
        await providerStore.getAllProvidersByClinic()
    } catch(err) {
        console.error('Error fetching providers by clinic:', err);
    }
}